import { Disclosure } from "@headlessui/react";
import {
  FolderIcon,
  FolderOpenIcon,
  ShareIcon,
  StarIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { classNames } from "../../../util";
import { Link } from "react-router-dom";

const defaultNavigation = [
  {
    name: "PDF Generator",
    icon: UsersIcon,
    current: true,
    children: [
      { name: "All", href: "#", icon: UsersIcon, current: true },
      { name: "Draft", href: "#", icon: FolderIcon },
      { name: "Active", href: "#", icon: FolderOpenIcon },
      { name: "Shared", href: "#", icon: ShareIcon },
      { name: "Starred", href: "#", icon: StarIcon },
    ],
  },
  {
    name: "Templates",
    icon: FolderIcon,
    current: false,
    children: [
      { name: "Exhibition", href: "#", count: 1 },
      { name: "Multi Art - Single Artist", href: "#", count: 5 },
      { name: "Multi Art - Multi Artist", href: "#", count: 0 },
      { name: "Internal Sales", href: "#", count: 10 },
      { name: "Blank", href: "#", count: 20 },
    ],
  },
];

const MenuItem = props => {
  const {
    count,
    current = false,
    href,
    icon,
    name,
    open,
    children,
  } = props || {};

  const cProps = {
    key: name,
    as: "a",
    href,
    className: classNames(
      current
        ? "bg-gray-100 text-gray-900"
        : "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
      "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50",
    ),
  };

  const ChildComponent = () => {
    return (
      <div className="flex flex-row items-center">
        {icon && (
          <props.icon
            className={classNames("mr-5 h-4 w-4 flex-shrink-0 text-black")}
            aria-hidden="true"
          />
        )}
        <span
          className={`hidden flex-1 text-sm text-gray-600 lg:block ${
            current && "underline"
          }`}
        >
          {name}
        </span>
        {count ? (
          <span
            className={classNames(
              current ? "bg-white" : "bg-gray-100 group-hover:bg-gray-200",
              "ml-3 inline-block rounded-full px-3 py-0.5 text-xs font-medium",
            )}
          >
            {count}
          </span>
        ) : null}
        {open !== undefined && (
          <svg
            className={classNames(
              open ? "rotate-90 text-gray-400" : "text-gray-300",
              "ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out group-hover:text-gray-400",
            )}
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
          </svg>
        )}
      </div>
    );
  };

  return (
    <>
      {children ? (
        <Disclosure.Button {...cProps}>
          <ChildComponent />
        </Disclosure.Button>
      ) : cProps.href ? (
        <Link className="flex cursor-pointer pb-8 pl-4" to={cProps.href}>
          <ChildComponent />
        </Link>
      ) : (
        <a {...cProps}>
          <ChildComponent />
        </a>
      )}
    </>
  );
};

const Sidebar = props => {
  const { open: drawerOpen, navigation = defaultNavigation } = props;
  return (
    <div
      className={`flex flex-col overflow-y-auto border-r border-gray-200 bg-white pb-4 pt-5 ${
        drawerOpen
          ? "w-full max-w-[250px] overflow-x-hidden lg:min-w-[250px]"
          : "hidden"
      } min-h-full`}
    >
      <div className="flex flex-grow flex-col">
        <nav className="flex-1 space-y-1 bg-white px-2" aria-label="Sidebar">
          {navigation?.map((item, index) =>
            !item?.children ? (
              <MenuItem key={item.name} {...item} />
            ) : (
              <Disclosure as="div" key={item.name} className="space-y-1">
                {({ open }) => (
                  <>
                    <MenuItem {...item} open={open} />
                    <Disclosure.Panel className="space-y-1">
                      {item?.children?.map((subItem, index) => (
                        <div key={index} className="ml-5 flex">
                          <MenuItem {...subItem} />
                        </div>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ),
          )}
        </nav>
      </div>
    </div>
  );
};

export { Sidebar };
